export const createFormattingFeatures = (editor) => ({
  toggleFormat(type, attrs = {}) {
    if (!editor) return;
    
    // Приводим тип к нижнему регистру для консистентности
    const formatType = type.toLowerCase();
    
    switch (formatType) {
      case 'bold':
      case 'italic':
      case 'underline':
      case 'strike':
      case 'code':
        editor.chain().focus().toggleMark(formatType).run();
        break;
      case 'heading':
        editor.chain().focus().toggleHeading(attrs).run();
        break;
      case 'bulletlist':
        editor.chain().focus().toggleBulletList().run();
        break;
      case 'orderedlist':
        editor.chain().focus().toggleOrderedList().run();
        break;
      case 'blockquote':
        editor.chain().focus().toggleBlockquote().run();
        break;
      default:
        console.warn(`Unknown format type: ${formatType}`);
    }
  },

  toggleTextAlign(alignment) {
    if (!editor) return;
    editor.chain().focus().setTextAlign(alignment).run();
  },

  clearFormatting() {
    if (!editor) return;
    editor.chain().focus().clearNodes().unsetAllMarks().run();
  },

  addHorizontalLine() {
    if (!editor) return;
    editor.chain().focus().setHorizontalRule().run();
  }
});
